import React from 'react';

const Footer = () => (
  <div className="news-main-footer notranslate" translate="no">
                            <div className="home-footer">

                               
                               <div className="footer-logo">
                                <img src="https://www.teluguone.com/images/live/tone_silver_jubilee_logo.png" alt="logo" />
                               </div>

                                <ul className="footer-nav">
                                     <li className="footer-nav-item">
                                     <a href="https://teluguone.com/news/" className="footer-nav-link" target="_blank">వార్తలు </a>
                                     </li>
                                      <li className="footer-nav-item">
                                     <a href="https://teluguone.com/tmdb/" className="footer-nav-link" target="_blank">సినిమా </a>
                                     </li>
                                      <li className="footer-nav-item">
                                     <a href="https://teluguone.com/movies/" className="footer-nav-link" target="_blank">చూడండి </a>
                                     </li>
                                      <li className="footer-nav-item">
                                      <a href="https://teluguone.com/photos/" className="footer-nav-link" target="_blank">ఫోటోలు </a>
                                
                                     </li> <li className="footer-nav-item">
                                      <a href="https://teluguone.com/devotional/" className="footer-nav-link" target="_blank">భక్తి </a>                
                                     </li>
                                     <li className="footer-nav-item">
                                       <a href="https://teluguone.com/news/contents/lifestyle-35.html"  className="footer-nav-link" target="_blank">జీవనశైలి</a>
                                     </li>
                                      <li className="footer-nav-item">
                                      <a href="https://teluguone.com/recipes/" className="footer-nav-link" target="_blank">ఆహారం </a>
                                     </li>
                                      <li className="footer-nav-item">
                                      <a href="https://teluguone.com/comedy/" className="footer-nav-link" target="_blank">వినోదం</a>
                                     </li>
                                      <li className="footer-nav-item">
                                      <a href="https://teluguone.com/news/contents/sports-53.html" className="footer-nav-link" target="_blank">క్రీడలు</a>
                                     </li>

                                      <li className="footer-nav-item">
                                       <a href="https://www.teluguone.com/grandalayam/"  className="footer-nav-link" target="_blank">గ్రంథాలయం </a>
                                     </li>
                                     
                                     <li className="footer-nav-item">
                                       <a href="https://www.teluguone.com/nri/"  className="footer-nav-link" target="_blank">ఎన్ఆర్ఐ కార్నర్ </a>
                                     </li>
                                     <li className="footer-nav-item">
                                       <a href="https://www.teluguoneradio.com/"  className="footer-nav-link" target="_blank">రేడియో </a>
                                     </li>
                                     <li className="footer-nav-item">
                                       <a href="https://teluguone.com/vanitha/"  className="footer-nav-link" target="_blank">వనిత </a>
                                     </li>
                                     {/* <li className="footer-nav-item">
                                       <a href="http://www.kidsone.in/"  className="footer-nav-link" target="_blank">కిడ్స్‌వన్ </a>
                                     </li> */}
                                       {/* <li className="footer-nav-item">
                                       <a href="https://teluguone.com/toneastrology/"  className="footer-nav-link" target="_blank">జ్యోతిష్యం </a>
                                     </li> */}
                                       {/* <li className="footer-nav-item">
                                       <a href="https://www.teluguone.com/sahityam/"   className="footer-nav-link" target="_blank">సాహిత్యం </a>
                                     </li> */}
                                    
                                    
                                    
                                </ul> 
                          
                              <h1 className="footer-copyright">2000-{new Date().getFullYear()}, TeluguOne.com, All rights reserved,  ObjectOne Information Systems Ltd.</h1>
                          </div>
  </div>
);

export default Footer;